import CrmDrawerPanel from './drawer-panel'

export { CrmDrawerPanel }